import i18n from "config/i18next";

i18n.addResources("es", "slotDetail", {
  state: "Estado",
  expiration: "Vencimiento",
  slotCode: "Código del turno",
  enrolled: "pickers Inscriptos",
  connected: "Conectados",
  idLabel: "ID picker",
  nameLabel: "Nombre y apellido",
  phoneLabel: "Teléfono",
  checkinLabel: "Hora check-in",
  idPlaceholder: "Ingresá el ID del picker",
  date: "Fecha",
  beginningLabel: "Comienzo del turno *",
  endLabel: "Fin del turno *",
  beginningPlaceholder: "Ingresá el horario de comienzo",
  endPlaceholder: "Ingresá el horario de finalización",
  region: "Región",
  oprationZone: "Zona de operación",
  registered: "Inscriptos ",
  capacityLabel: "Capacidad *",
  capacityPlaceholder: "Ingresá la capacidad",
  disabledPickerError: "El ID no corresponde a picker activo",
  pickerNotAvailableError: "El ID no se encuentra disponible",
  invalidRegionError: "El ID no pertenece a la región del turno",
  deletePickerTitle: "Estás por eliminar a un picker",
  deletePickerMessage: "¿Realmente querés eliminarlo?",
  deletePickerButton: "Sí, eliminar",
  deletionNotAllowedTitle: "No es posible eliminar este picker",
  deletionNotAllowedMessage: "Por favor, verificá e intentá nuevamente",
  editSlotErrorTitle: "No es posible editar el turno",
  editSlotErrorMessage: "Por favor, verificá los datos e intentá nuevamente",
  successTitle: "Turno modificado con éxito",
  successMessage: "Los cambios quedaron registrados",
  deleteErrorTitle: "No es posible eliminar este turno",
  deleteErrorMessage: "Por favor, verificá e intentá nuevamente",
  deleteTitle: "Estás por eliminar el turno",
  deleteMessage: "¿Realmente querés eliminarlo?",
  newPickerTitle: "Confirmá la inscripción",
  newPickerMessage: "Si te vas sin guardar, no se agregará al picker",
  minCapacityError: "Debe ser mayor a la ocupación actual",
  bulkDeleteSlotTitle: "Estás por eliminar los turnos",
  bulkDeleteSlotMessage: "¿Realmente querés eliminarlos?",
  overlapedPickersTitle: "Turnos solapados",
  overlapedPickersMessage:
    "Los pickers inscriptos en turnos en el mismo horario, pero en otras zonas serán eliminados",
  reduceSlotTimeError: "No se puede reducir el horario",
  reduceCapacityError: "No pueden ser menos que {{amount}}",
});
